var map = {
	"./about_ee.json": 8554,
	"./about_en.json": 5571,
	"./privacyPolicy_ee.json": 2367,
	"./privacyPolicy_en.json": 262,
	"./privacyPolicy_ru.json": 4880,
	"./termsOfService_ee.json": 1326,
	"./termsOfService_en.json": 7095,
	"./termsOfService_ru.json": 3265,
	"./testingModal_temp/ee.json": 341,
	"./testingModal_temp/en.json": 4144,
	"./testingModal_temp/ru.json": 2778
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7034;
module.exports = webpackAsyncContext;